// extracted by mini-css-extract-plugin
export var modal = "_ed-0";